'use strict';

import 'angular';

import inputsModule from './inputs';
import slidesModule from './slides';
import timeModule from './time';

const MODULE_NAME = 'brg.components';

angular.module(MODULE_NAME, [
	inputsModule,
	slidesModule,
	timeModule,
]);

export default MODULE_NAME;
